// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Bs-C","title":"Images90_title__1XqNc","images":"Images90_images__1ztw0"};